import { render, staticRenderFns } from "./ShopProduct.vue?vue&type=template&id=111799e2&scoped=true&"
import script from "./ShopProduct.vue?vue&type=script&lang=js&"
export * from "./ShopProduct.vue?vue&type=script&lang=js&"
import style0 from "./ShopProduct.vue?vue&type=style&index=0&id=111799e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111799e2",
  null
  
)

export default component.exports